import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit, Directive, ElementRef, EventEmitter, Inject, Input, OnDestroy, Output, PLATFORM_ID
} from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { LazyLoadObserverService } from './lazy-load-observer.service';


@Directive({
  selector: '[lazyLoad]'
})
export class LazyLoadElementsDirective implements AfterViewInit, OnDestroy {

  @Input() public preRender: boolean = true;
  @Output() public lazyLoad: EventEmitter<any> = new EventEmitter();

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private readonly element: ElementRef,
    private readonly lazyLoadObserverService: LazyLoadObserverService,
    @Inject(PLATFORM_ID) private readonly platformId: Record<string, unknown>
  ) {}

  public ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) {
      if (this.preRender) {
        this.load();
        return;
      }
    }

    this.lazyLoadObserverService.observeElement(this.element.nativeElement).pipe(
      takeUntil(this.ngUnsubscribe),
      take(1)
    ).subscribe(() => {
      this.load();
    });
  }

  public ngOnDestroy() {
    this.lazyLoadObserverService.unobserveElement(this.element.nativeElement);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private load(): void {
    this.lazyLoad.emit();
  }

}
